import { decodeToken } from "react-jwt";
import { createPersistedStorage } from "src/utility/storage";

type DecodedToken = { exp?: number };

const tokenStorage = createPersistedStorage<string>("rc.authToken", { raw: true });

export const writePersistedToken = tokenStorage.write;
export const clearPersistedToken = tokenStorage.clear;

export const readPersistedToken = (): string | null => {
  const token = tokenStorage.read();
  if (!token) return null;

  const decoded = decodeToken(token) as DecodedToken | null;
  const isExpired = !decoded?.exp || decoded.exp * 1000 <= Date.now();
  if (isExpired) {
    clearPersistedToken();
    return null;
  }

  return token;
};
